import { fullName } from "helpers/name-helpers";
import { useAppSelector } from "redux/hooks";
import { selectUserById } from "redux/slices/client";

export function FullName({ userId, defaultName }: { userId?: number; defaultName?: string }) {
  const user = useAppSelector((state) => selectUserById(state, userId));

  return <>{user !== undefined ? fullName(user) : defaultName || ""}</>;
}
